import ChartBox from "components/ChartBox"
import BarTooltip from "components/Charts/Nivo/tooltips/BarTooltip"
import VerticalBars from "components/Charts/Nivo/VerticalBars"
import { pregnantRisks } from "theme/charts/default"

interface Props {
    data: any
}

const PregnantRisk = ({ data }: Props) => {
    
    const buildChartData = (values: any) => {
        return [
            {
                "id": "habitual",
                "label": "Habitual",
                "value": values.low,
            },
            {
                "id": "alto_pc",
                "label": "Alto com PC",
                "value": values.high_pc,
            },
            {
                "id": "alto",
                "label": "Alto",
                "value": values.high,
            },
        ]
    }

    const colorBy = (label: string): string => {
        switch(label) {
            case "Habitual": return pregnantRisks[0];
            case "Alto com PC": return pregnantRisks[1];
            case "Alto": return pregnantRisks[2];
            default: return pregnantRisks[0]
        }
    }
    
    return (
        <ChartBox title="Riscos Atribuídos na Avaliação Gestacional">
            <VerticalBars 
                data={buildChartData(data)}
                tooltip={BarTooltip}
                customColors={pregnantRisks}
                colorBy={colorBy}
            />
        </ChartBox>
    )
}

export default PregnantRisk